import axios from 'axios'
import { getRefreshToken } from 'utils/cookies'
import { generateBaseUri } from 'utils/helper'
import { getStoredFcmToken } from 'utils/pushNotification'

const resource = 'authentication'

export const login = (email, password, remember) => {
  const data = {
    email,
    password,
    remember_me: remember,
  }

  return axios.post(`/${resource}/login`, data, { headers: { Authorization: false } })
}

/**
 * Login dengan JWT (use_jwt = true)
 * Response: access_token, refresh_token
 */
export const singleLogin = (email, password, remember = 0, withOtp = 0) => {
  const data = {
    email,
    password,
    remember_me: remember,
    is_otp: withOtp,
    use_jwt: 1, // Backend JWT flow
    include_init: 0, // Backward compatibility: jangan auto-init
  }

  return axios.post(`/${resource}/singleLogin`, data, {
    baseURL: generateBaseUri({ ignoreInitEndpoint: true }),
    headers: { Authorization: false },
  })
}

export const verifyGoogleToken = (code) => {
  const data = {
    code,
    include_init: 0, // Backward compatibility: jangan auto-init
  }

  return axios.post(`/google-auth/verify`, data, { headers: { Authorization: false } })
}
export const verifyFacebookToken = (access_token) => {
  return axios.post(
    `/facebook-login/token`,
    { access_token },
    { headers: { Authorization: false } },
  )
}

export const updateProfile = (data) => {
  return axios.put(`/${resource}/user`, data)
}

export const changePassword = (data) => {
  return axios.put(`/${resource}/password`, data)
}

export const revokeLogin = () => {
  return axios.post(`/authentication/revoke`)
}

export const invite = (data) => {
  return axios.post(`/users/register`, data, { headers: { Authorization: false } })
}

export const acceptInvitation = (data) => {
  return axios.post(`/users/acceptInvitation`, data, { headers: { Authorization: false } })
}

export const reset = (data) => {
  return axios.post(`/authentication/password/recovery/reset`, data, {
    headers: { Authorization: false },
  })
}

export const changeLanguage = (lang) => {
  return axios.patch(`/${resource}/user/lang`, { lang })
}

/**
 * Logout JWT: Revoke sesi dengan mengirim refresh_token
 * Setelah itu hapus seluruh token dari storage (clearAuthTokens)
 * `device_token` (token FCM perangkat ini) membuat BE melepas token tsb dari
 * user yang logout; token tak dikenal diabaikan BE tanpa error.
 */
export const logout = () => {
  const refreshToken = getRefreshToken()
  const deviceToken = getStoredFcmToken()
  const payload = {
    ...(refreshToken ? { refresh_token: refreshToken } : {}),
    ...(deviceToken ? { device_token: deviceToken } : {}),
  }
  return axios.post(`/${resource}/logout`, payload, {
    baseURL: generateBaseUri({ ignoreInitEndpoint: true }),
  })
}

export const loginWithSso = (data) => {
  return axios.post(`/sso/login`, data, { headers: { Authorization: false } })
}

export const getUserByToken = (token) => {
  return axios.get(`/users/register/${token}`, { headers: { Authorization: false } })
}

export const generateOtp = (data) => {
  return axios.post(`/${resource}/generateOtp`, data, { headers: { Authorization: false } })
}

export const resetPin = (data, config = {}) => {
  return axios.patch(`/users/${data.id}/pin/reset`, data, config)
}

export const validatePin = (data, config = {}) => {
  return axios.post(`/users/${data.id}/pin/validate`, data, config)
}

export const globalSearch = (params) => {
  return axios.get('/finance/globalSearch', { params })
}

/**
 * Refresh JWT token
 * Payload: { refresh_token }
 * Response: { data: { access_token, refresh_token, token_type, expires_at, refresh_expires_at } }
 */
export const refreshToken = (data) => {
  return axios.post(`/${resource}/refresh`, data, {
    baseURL: generateBaseUri({ ignoreInitEndpoint: true }),
    headers: { Authorization: false },
    // Refresh berjalan di dalam Web Lock lintas tab → jangan sampai menggantung lama
    timeout: 30000,
  })
}
